import { useFela } from 'react-fela';
import classnames from 'classnames';
import * as PropTypes from 'prop-types';

import Empty from 'antd/lib/empty';

import { fileShape } from 'modules/uploader';

import Image from '../Image';

import rule from './ImageList.rule';

const ImageList = ({ images }) => {
    const { css } = useFela();

    return (
        <div className={classnames('ImageList', css(rule))}>
            {images.map(image => (
                <Image key={image.uid} {...image} />
            ))}
            {!images.length && <Empty />}
        </div>
    );
};

ImageList.propTypes = {
    images: PropTypes.arrayOf(fileShape),
};

ImageList.defaultProps = {
    images: [],
};

ImageList.propTypes = {};

export default ImageList;
